export const METADATA_INITIAL_FILTER = {
  info_1: '',
  info_2: '',
  info_3: '',
  info_4: '',
  info_5: '',
  info_6: '',
  info_7: '',
  info_1_rule: '',
  info_2_rule: '',
  info_3_rule: '',
  info_4_rule: '',
  info_5_rule: '',
  info_6_rule: '',
  info_7_rule: '',
  info_1_list: [],
  info_2_list: [],
  info_3_list: [],
  info_4_list: [],
  info_5_list: [],
  info_6_list: [],
  info_7_list: [],
}
